import type { ReferralResponse } from '../types';

import { getCampaignCookie } from './getCampaignCookie';

export const getTgtgReferral = (route: any) => {
  const campaign = getCampaignCookie(document);

  let referral: ReferralResponse = {};

  if (campaign.length) {
    referral.referred_by = `?${campaign.join('&').replace(/&$/, '')}`;
  }

  if (referral.referred_by) {
    if (typeof route.query.store_name === 'string') {
      referral.store_name = route.query.store_name;
    }

    if (typeof route.query.logo === 'string') {
      referral.logo = route.query.logo;
    }
  }

  return Object.keys(referral).length > 0 ? referral : undefined;
};
